import ApiService from "./api.service";

export default {
  getAdministradores(opcoes = { showOverlay: true }) {
    return ApiService.get("/super-admin", null, opcoes["showOverlay"]);
  },

  getUsuarios(q, opcoes = { showOverlay: false }) {
    return ApiService.get(
      "/super-admin/buscar-usuarios?q=" + q,
      null,
      opcoes["showOverlay"]
    );
  },

  contasPermitidas(params, opcoes = { showOverlay: true }) {
    return ApiService.post(
      `super-admin/${params.usuario_id}/contas-permitidas`,
      { contas: params.contas },
      null,
      opcoes["showOverlay"]
    );
  },

  trocarGrupo(params, opcoes = { showOverlay: true }) {
    return ApiService.post(
      `super-admin/${params.usuario_id}/role`,
      { role_id: params.role_id },
      null,
      opcoes["showOverlay"]
    );
  }
};
